import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertCoins, getCointConvertUrl, getExchangeValue } from '../services/assetsService';
import { useFetch } from './useFetch';

export const useEthConverter = (name = 'ethUsd') => {
  const ethEqu = useSelector(({ general }) => general.converter?.[name]);
  const hordUsdEqu = useSelector(({ general }) => general.converter?.hordUsd);
  const bnbUsdEqu = useSelector(({ general }) => general.converter?.bnbUsd);

  const ethInUsd = useMemo(() => getExchangeValue(ethEqu, 'ethereum', 'usd'), [ethEqu]);
  const hordInUsd = useMemo(() => getExchangeValue(hordUsdEqu, 'hord', 'usd'), [hordUsdEqu]);
  const bnbInUsd = useMemo(() => getExchangeValue(bnbUsdEqu, 'binancecoin', 'usd'), [bnbUsdEqu]);

  const usdToEth = useCallback((usd) => (usd / ethInUsd).toFixed(6), [ethEqu]);
  const ethToUsd = useCallback((usd) => (ethInUsd * usd).toFixed(4), [ethEqu]);

  const usdToHord = useCallback((usd) => (usd / hordInUsd).toFixed(6), [hordUsdEqu]);
  const hordToUsd = useCallback((usd) => (hordInUsd * usd).toFixed(4), [hordUsdEqu]);
  const hordToEth = useCallback((hord) => usdToEth(hordToUsd(hord)), [hordUsdEqu, ethEqu]);

  const usdToBnb = useCallback((usd = 0) => (usd / bnbInUsd).toFixed(3), [bnbUsdEqu]);
  const bnbToUsd = useCallback((usd = 0) => (bnbInUsd * usd).toFixed(2), [bnbUsdEqu]);

  const hordToolKit = {
    usdToHord,
    hordToUsd,
    hordToEth,
  };

  const mergedToolKit = {
    eth: [ethToUsd, usdToEth],
    bnb: [bnbToUsd, usdToBnb, bnbInUsd],
  };

  return [ethToUsd, usdToEth, ethInUsd, hordToolKit, mergedToolKit];
};
